import React, { Component } from 'react';
import ReactSVG from 'react-svg';
import styled from 'styled-components';

const SvgCirlceWrapper = styled.div`
  display: block;
  position: absolute;
  left: -4px;
  top: -15px;
  height: 0;
`

const SvgCircle = props => {
    const { strokeColor } = props
    return (
        <SvgCirlceWrapper>
            <svg height="20" width="20"><circle cx="6" cy="10" r="6" stroke={strokeColor} strokeWidth="2" fill="white"></circle></svg>
        </SvgCirlceWrapper>
    )
}

export default SvgCircle